import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface Person {
    firstName: string
    lastName: string
    jobTitle: string
    email: string
    businessPhone: string
    extension: string
    cellPhone: string
}

export interface User extends Person {
    authorizedOfficer: boolean
}

const initialState: User = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    email: '',
    businessPhone: '',
    extension: '',
    cellPhone: '',
    authorizedOfficer: true,
};

export const userSlice = createSlice({
    name: 'user',

    initialState,

    reducers: {
        setUser(state, action: PayloadAction<User>) {
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.jobTitle = action.payload.jobTitle;
            state.email = action.payload.email;
            state.businessPhone = action.payload.businessPhone;
            state.extension = action.payload.extension;
            state.cellPhone = action.payload.cellPhone;
            state.authorizedOfficer = action.payload.authorizedOfficer;
        },
    },
});

export const userActions = userSlice.actions;
export type UserSlice = {
    [userSlice.name]: ReturnType<typeof userSlice['reducer']>
};
